import Cookies from "js-cookie";
document.addEventListener("DOMContentLoaded", () => {

  const regionalContent = () => {
    if (undefined !== typeof GEOIP) {
      const elements = document.querySelectorAll('div[data-country="' + GEOIP.country + '"], button[data-country="' + GEOIP.country + '"]');
      if (elements.length > 0) {
        elements.forEach(function (el) {
          if (el.hasAttribute('data-parent-id')) {
            el.style.display = "flex";
          } else {
            if ('LI' === el.tagName) {
              el.style.display = "list-item";
            } else {
              el.style.display = "block";
            }
          }
        });
      } else {
        const default_el = document.getElementById("banner-default");
        if (default_el !== null) {
          default_el.style.display = 'flex';
        }
      }

      // risk warning
      var rw = document.getElementById("rw-text");
      var rw_country = document.getElementById("rw-text-" + GEOIP.country);
      if (rw !== null && rw_country !== null) {
        rw.innerText = rw_country.innerText;
      }
    }
  }

  regionalContent();

  if (window.GEOIP.country === "KE") {
    var rw = document.getElementById("headerRiskWarning");
    var footerRwWrapper = document.getElementById("rw-wrapper");
    var headerScrollable = document.getElementById("hs");
    rw.style.display = "block";
    footerRwWrapper.style.display = "none";
    headerScrollable.style.marginTop = "auto";
  }

  const ext_reg_btn = document.getElementById("ext-reg-btn");
  let agent = Cookies.get("agent[agent_id]");
  if (ext_reg_btn !== null && agent !== undefined && -1 === ext_reg_btn.href.indexOf('partner_id')) {
    ext_reg_btn.href = ext_reg_btn.href + '?partner_id=' + agent;
  }

  let s = Cookies.get('seminar_id');
  if (s !== undefined) {
    Cookies.remove('seminar_id', {path:'', domain: '.forextime.com'});
  }

  let login_lnks = document.querySelectorAll('a.ext-login');
  login_lnks.forEach(function(el) {
    if (window.GEOIP.country && -1 !== ['VN', 'MY', 'ID', 'KR', 'TH'].indexOf(window.GEOIP.country)) {
      s = '';
      if (el.href.indexOf('?') !== -1) {
        s = el.href.slice(1);
      }
      el.href = drupalSettings.fxi_redirect.legacyLogin + s;
    }
  });

  let login_links = document.querySelectorAll('a.ext-login, a.language-link');
  let g = '';
  function getCookie(r){return document.cookie.split("; ").reduce(((e,t)=>{const[a,n]=t.split("=");return a===r?decodeURIComponent(n):e}),null)}function getURLParameter(r){return new URLSearchParams(window.location.search).get(r)}const referralParam=getURLParameter("Referral"),formxParam=getURLParameter("Formx"),subId=getURLParameter("sub_id");if(referralParam)g=`?Referral=${referralParam}`,subId&&(g+=`&sub_id=${subId}`);else if(formxParam)g=`?Formx=${formxParam}`,subId&&(g+=`&sub_id=${subId}`);else{const r=getCookie("user_partners");if(r)try{const e=JSON.parse(r);e.id&&"fynxt_partner"===e.type?g=/^\d+$/.test(e.id)?`?Referral=${e.id}`:`?Formx=${e.id}`:e.fynxt_partner&&e.fynxt_partner.current&&(g=/^\d+$/.test(e.fynxt_partner.current)?`?Referral=${e.fynxt_partner.current}`:`?Formx=${e.fynxt_partner.current}`),e.sub_id&&(g+=`&sub_id=${e.sub_id}`)}catch(r){console.warn("Invalid cookie format:",r)}}
  login_links.forEach(function(el) {
    // el.addEventListener('click', function(e) {
    //   e.preventDefault();
    if (-1 === el.href.indexOf('Referral') && -1 === el.href.indexOf('Formx')) {
      if (el.href.indexOf('?') !== -1) {
        el.href = el.href + '&'+g.slice(1);
      } else {
        el.href = el.href + g;
      }
    }
    // window.location.href = this.href + g;
    // });
  });

});